import { UMR } from './tokens';

/**
 * Correctifs de style locaux au prototype.
 * UrbanMap force le texte d'aide des champs en noir (`UMForm`), ce qui laisse croire
 * que le champ est déjà saisi : on le repasse en gris, comme sur les écrans UM récents.
 */
export function PlanFormStyles() {
  return (
    <style>{`
      .pcv3-station-nearby {
        font-size: var(--nj-semantic-font-size-text-xs-desktop);
        padding: 0 var(--nj-semantic-size-spacing-4);
        background: ${UMR.grey100};
        border: var(--nj-semantic-size-border-width) solid ${UMR.border};
        color: ${UMR.textSecondary};
        font-weight: 400;
      }
      .pcv3-project-description {
        --nj-semantic-font-size-text-md-desktop: var(--nj-semantic-font-size-text-xs);
        --nj-semantic-font-family-default: system-ui;
      }
      input.um-input::placeholder { color: ${UMR.textPlaceholder}; opacity: 1; }
      .plan-panel input::placeholder, .plan-panel textarea::placeholder { color: ${UMR.textPlaceholder}; opacity: 1; }
      .pcv3-creation-panel input.um-input[aria-label="Nom du projet"],
      .pcv3-creation-panel input.um-input[aria-label="Rechercher une commune"],
      .pcv3-creation-panel input.um-input[aria-label="Rechercher un réseau de chaleur"] {
        font-size: var(--nj-semantic-font-size-text-xs-desktop) !important;
      }
    `}</style>
  );
}
